import { render } from "./VIcon.vue?vue&type=template&id=78fd460a&scoped=true"
import script from "./VIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./VIcon.vue?vue&type=script&setup=true&lang=js"

import "./VIcon.vue?vue&type=style&index=0&id=78fd460a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fd460a"],['__file',"src/components/UI/iconComponents/VIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78fd460a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78fd460a', __exports__)) {
    api.reload('78fd460a', __exports__)
  }
  
  module.hot.accept("./VIcon.vue?vue&type=template&id=78fd460a&scoped=true", () => {
    api.rerender('78fd460a', render)
  })

}


export default __exports__